import { Button, Icon, makeStyles } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import React, { useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { toastr } from '../_components/toastr';
import { history } from '../_helpers/history';
import { userLocationService } from '../_services';

const useStyles = makeStyles(theme => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: theme.spacing(2),
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    heading: {
        backgroundColor: theme.palette.primary.main,
        color: "white",
        marginLeft: theme.spacing(-1),
        marginTop: theme.spacing(-4),
        marginRight: theme.spacing(-1),
        padding: theme.spacing(2),
        paddingBottom: theme.spacing(1)
    },
    closeButton: {
        float: "right",
        paddingTopt: theme.spacing(1)
    },
    appScreen: {
        backgroundColor: "#181c37",
        backgroundImage: "url('images/dark-tire.png')",
    },

    coolmoreLogo: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    appContainer: {
        paddingTop: theme.spacing(4),
    },
    drawer: {
        padding: theme.spacing(1)
    },
}));

export function LocationCreate({ successCallback }) {

    const [isLoading, setLoading] = useState(false);
    const [receiveNotificationEmails, setReceiveNotificationEmails] = useState(true);
    const [location, updateLocation] = useState({ name: '', email: '', password: '', role: '', department: '' });
    const classes = useStyles();

    function goTo(link) {
        history.push('/' + link);
    }

    function navigateBack() {
        history.push('/Locations');
    };

    function submit(e) {
        e.preventDefault();
        setLoading(true);

        var _location = location;
        _location.roles = [location.role];
        _location.receiveNotificationEmails = receiveNotificationEmails;

        userLocationService
            .post(_location)
            .then(
                (d) => { console.log(d); successCallback(); navigateBack(); },
                (e) => { console.log(e); setLoading(false); toastr.error("Something went wrong. Please try again later") }
            );
    }

    function handleChange(event) {
        var _location = location;
        _location[event.target.name] = event.target.value;
        updateLocation({ ..._location });
    };

    function handleReceiveNotificationsChange() {
        setReceiveNotificationEmails(prev => !prev);
    }

    return (
        <>
            <Drawer anchor="right" open={true} onClose={navigateBack} variant="temporary">

                <div
                    tabIndex={0}
                    className={classes.drawer}
                    role="button">
                    <div className="padding-sm">

                        <div className={classes.heading}>
                            <h4>
                                Create Location

                                <Icon className={classes.closeButton} onClick={navigateBack}>
                                    close
                                </Icon>
                            </h4>
                        </div>

                        <ValidatorForm className={classes.form} onSubmit={submit} noValidate autocomplete="off">
                            <TextValidator
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                label="Location Name"
                                name="name"
                                value={location.name}
                                disabled={isLoading}
                                onChange={handleChange}
                                validators={['required']}
                                errorMessages={['This field is required']}
                                autoFocus
                            />


                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                disabled={isLoading}
                                disableElevation
                                className={classes.submit}
                            >
                                <Icon>check</Icon> Save
                            </Button>

                        </ValidatorForm>
                    </div>
                </div>
            </Drawer>
        </>
    );
}